class PdpProductInfo {
  constructor(sectionEl) {
    this.section = sectionEl;
    this.sectionId = sectionEl.dataset.pdpSection;
    this.totalPriceEl = sectionEl.querySelector(`#pdp-total-price-${this.sectionId}`);
    this.quantityInput = sectionEl.querySelector(`#Quantity-${this.sectionId}`);
    this.upgradeItems = sectionEl.querySelectorAll('.pdp-upgrade-item');
    this.bundleCards = sectionEl.querySelectorAll('[data-bundle-card]');
    this.subscriptionCards = sectionEl.querySelectorAll('[data-subscription-card]');
    this.basePrice = parseInt(this.totalPriceEl?.dataset.basePrice || '0', 10);
    this.baseProductPrice = this.basePrice;
    this.productForm = document.querySelector(`product-form[data-section-id="${this.sectionId}"]`);
    this.variantInput = this.productForm?.querySelector('input[name="id"].product-variant-id');
    this.subSelect = sectionEl.querySelector('.pdp-sub-card__select');
    this.submitBtn = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
    this.submitBtnLabel = this.submitBtn?.querySelector('span');
    this.addToCartBaseText = this.submitBtnLabel?.textContent.trim() || '';
    this.showButtonPrice = sectionEl.classList.contains('pdp-info--no-bundles');
    this.selectedCard = sectionEl.querySelector('[data-bundle-card].pdp-bundle-card--selected') || this.bundleCards[this.bundleCards.length - 1];
    this.selectedCardSubscription = sectionEl.querySelector('[data-subscription-card].pdp-bundle-card--selected') || this.subscriptionCards[this.subscriptionCards.length - 1];
    this.dynamicSubscriptionContainer = sectionEl.querySelector('[data-dynamic-subscription-container]');
    this.shouldRerenderBundleSubscription = window.pdpBundleSubscriptionRerender === true;
    this.subscriptionCardsWithoutBundles = sectionEl.querySelectorAll('.pdp-bundles.pdp-no-bundles [data-bundle-card]');
    this.subscriptionOptions = this.subSelect?.querySelectorAll('option');

    this.initBundleCards();
    this.initSubscriptionCards();
    this.initSubSelect();
    this.initSellingPlanSync();
    this.initUpgradeItems();
    this.initQuantityButtons();
    this.initFormSubmit();
    this.initVariantChange();
    this.setBundleInfoSubscription(this.selectedCard);
    this.initRecurringAccordion();


    if (this.selectedCard) {
      this.applyBundleSelection(this.selectedCard);
    }

    if (this.selectedCardSubscription) {
      this.applySubscriptionSelection(this.selectedCardSubscription);
    }

    if (!this.selectedCard && !this.selectedCardSubscription) {
      this.updateTotal();
    }
  }

  initVariantChange() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    this.variantUnsub = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      if (!data || data.sectionId !== this.sectionId) return;
      const newPrice = data.variant?.price;
      const sellingPlanPrice = data.variant?.selling_plan_allocations?.[0]?.price;
      const newVariantId = data.variant?.id;
      if (typeof newPrice === 'number') {
        this.baseProductPrice = newPrice;
        const baseCard = this.section.querySelector('[data-bundle-base]') || this.section.querySelector('[data-bundle-card]');
        if (baseCard) {
          baseCard.dataset.price = String(newPrice);
        }
        const subscriptionCardPrice = this.section.querySelector('[data-sub-price]');
        if (subscriptionCardPrice) {
           subscriptionCardPrice.textContent = this.formatMoney(sellingPlanPrice);
        }
        const oneTimePurchasePrice = this.section.querySelector('.pdp-bundle-card--onetime .pdp-bundle-card__price');
        if (oneTimePurchasePrice) {
           oneTimePurchasePrice.textContent = this.formatMoney(newPrice);
        }
      }
      if (this.selectedCard?.hasAttribute('data-bundle-base') || this.selectedCard?.hasAttribute('data-bundle-card')) {
        if (typeof newPrice === 'number') {
          const isSubscriptionSelected = this.section.querySelector('.pdp-bundle-card--sub.pdp-bundle-card--selected[data-is-sub="true"]');
          if(isSubscriptionSelected) {
            this.basePrice = sellingPlanPrice;
            if (this.totalPriceEl) this.totalPriceEl.dataset.basePrice = String(sellingPlanPrice);
          }
          const isOneTimeSelected = this.section.querySelector('.pdp-bundle-card--onetime.pdp-bundle-card--selected[data-is-sub="false"]');
          if(isOneTimeSelected) {
            this.basePrice = newPrice;
            if (this.totalPriceEl) this.totalPriceEl.dataset.basePrice = String(newPrice);
          }
          
        }
        if (newVariantId && this.variantInput) {
          this.variantInput.value = String(newVariantId);
        }

        if(this.subscriptionCardsWithoutBundles) {
          this.subscriptionCardsWithoutBundles.forEach(c => {
            c.setAttribute('data-variant-id', newVariantId);
            if(c.classList.contains('pdp-bundle-card--sub')) {
             c.setAttribute('data-price', sellingPlanPrice);
            } else {
             c.setAttribute('data-price', newPrice);
            }        
        });
        }

        if(this.subscriptionOptions) {
          this.subscriptionOptions.forEach(c => {
            c.setAttribute('data-price', sellingPlanPrice);
        });
        }
        
        this.updateTotal();
      }

    });
  }

  initBundleCards() {
    this.bundleCards.forEach(card => {
      card.addEventListener('click', () => {
        console.log("subscription/bundle card clicked");
        this.applyBundleSelection(card);

        this.setBundleInfoSubscription(card);

        if (card.dataset.isSub === 'true' && this.shouldRerenderBundleSubscription === true) {
          this.renderBundleSubscription(card);
        }

        const selectedSubscription = this.section.querySelector(
          '[data-subscription-card].pdp-bundle-card--selected'
        );

        if (selectedSubscription) {
          this.applySubscriptionSelection(selectedSubscription);
        }

        if (card.dataset.isSub === 'false' && this.dynamicSubscriptionContainer) {
          this.dynamicSubscriptionContainer.style.display = 'none';
        }

        if (card.dataset.isSub === 'true' && this.dynamicSubscriptionContainer) {
          this.dynamicSubscriptionContainer.style.display = '';
        }

        if(!this.shouldRerenderBundleSubscription) {
          this.populateReplenishableLiquids(card);
        }
        

      });
    });
  }

  initSubscriptionCards() {
    this.subscriptionCards.forEach((card, index) => {
      card.addEventListener('click', () => {
        console.log("subscription card clicked");
        this.selectedSubscriptionIndex = index;
        this.applySubscriptionSelection(card);
      });
    });
  }

  applyBundleSelection(card) {
    this.bundleCards.forEach(c => c.classList.remove('pdp-bundle-card--selected'));
    card.classList.add('pdp-bundle-card--selected');
    this.selectedCard = card;

    const price = parseInt(card.dataset.price, 10);
    if (Number.isFinite(price)) {
      this.basePrice = price;
      if (this.totalPriceEl) this.totalPriceEl.dataset.basePrice = String(price);
    }

    if (this.variantInput && card.dataset.variantId) {
      this.variantInput.value = card.dataset.variantId;
    }

    this.syncSellingPlan();
    this.refreshSealSubsWidget(card);
    this.updateTotal();
  }

  setBundleInfoSubscription(card) {
    if (!this.subscriptionCards) return;
    this.subscriptionCards.forEach(c => {
      c.setAttribute('data-variant-id', card.dataset.variantId);
      c.setAttribute('data-handle', card.dataset.handle);
      c.setAttribute('data-price', card.dataset.price);
      c.setAttribute('data-product', card.dataset.productJson);
      const product = JSON.parse(card.dataset.productJson);

      const cardPrice = c.querySelector('[data-sub-price]');

      if (cardPrice && card.dataset.isSub === 'true') {
        const subscriptionPrice = product.variants[0].selling_plan_allocations[0].price;
        cardPrice.textContent = this.formatMoney(subscriptionPrice);
        if(this.subscriptionOptions) {
          this.subscriptionOptions.forEach(c => {
            c.setAttribute('data-price', subscriptionPrice);
        });
        }
      }

      const cardPriceOneTime = c.querySelector('.pdp-bundle-card__price');
      if (cardPriceOneTime) {
        cardPriceOneTime.textContent = this.formatMoney(card.dataset.price);
      }

    });
    this.initSubSelect();
  }

  applySubscriptionSelection(card) {
    this.subscriptionCards.forEach(c => c.classList.remove('pdp-bundle-card--selected'));
    card.classList.add('pdp-bundle-card--selected');
    this.selectedCard = card;

    const product = JSON.parse(card.dataset.product) || JSON.parse(card.dataset.productJson);

    let price;

    if (card.dataset.isSub === 'true') {
      const subscriptionPrice = product.variants[0].selling_plan_allocations?.[0]?.price;
      price = parseInt(subscriptionPrice, 10);
    } else {
      price = parseInt(card.dataset.price, 10);
    }

    if (Number.isFinite(price)) {
      this.basePrice = price;

      if (this.totalPriceEl) {
        this.totalPriceEl.dataset.basePrice = String(price);
      }
    }

    if (this.variantInput && card.dataset.variantId) {
      this.variantInput.value = card.dataset.variantId;
    }

    this.syncSellingPlan();
    this.refreshSealSubsWidget(card);
    this.updateTotal();
  }

  async renderBundleSubscription(card) {
    if (!this.shouldRerenderBundleSubscription) return;
    if (!this.dynamicSubscriptionContainer) return;

    const handle = card.dataset.handle;

    if (!handle) return;

    try {
      const response = await fetch(
        `/products/${handle}?section_id=pdp-subscription-plans`
      );

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const html = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const subscriptionPlans = doc.querySelector(
        '.pdp-bundles__subscription-plans'
      );

      this.dynamicSubscriptionContainer.innerHTML = '';
      this.dynamicSubscriptionContainer.appendChild(subscriptionPlans);

      this.subscriptionCards =
        this.dynamicSubscriptionContainer.querySelectorAll(
          '[data-subscription-card]'
        );

      this.subSelect =
        this.dynamicSubscriptionContainer.querySelector(
          '.pdp-sub-card__select'
        );

      const selectedSubscription =
        this.dynamicSubscriptionContainer.querySelector(
          '[data-subscription-card].pdp-bundle-card--selected'
        );

      this.refreshSealSubsWidget(card);
      this.updateTotal();
      this.initSubscriptionCards();
      this.initSubSelect();
      this.syncSellingPlan();
      this.applyBundleSelection(card);
      this.applySubscriptionSelection(selectedSubscription);
      this.initRecurringAccordion();

    } catch (error) {
      console.error(
        'Failed to render bundle subscription plans:',
        error
      );

      this.dynamicSubscriptionContainer.innerHTML = '';
      this.selectedCardSubscription = null;
      this.subscriptionCards = [];
      this.subSelect = null;
    }


  }

  initSubSelect() {
    if (!this.subSelect) return;
    this.subSelect.addEventListener('change', () => {
      this.onSubPlanChange();
    });
  }

  initSellingPlanSync() {
    if (!this.subSelect || !this.productForm) return;
    const form = this.productForm.querySelector('form') || this.productForm;
    form.addEventListener('submit', () => this.syncSellingPlan(), true);
  }

  syncSellingPlan() {
    if (!this.subSelect || !this.productForm) return;
    const form = this.productForm.querySelector('form') || this.productForm;
    const plan = this.selectedCard?.dataset.sellingPlan || '';
    let inputs = [...form.querySelectorAll('input[name="selling_plan"]')];
    if (inputs.length === 0) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'selling_plan';
      form.appendChild(input);
      inputs = [input];
    }
    inputs.forEach(input => {
      input.value = plan;
      input.disabled = !plan;
    });
  }

  onSubPlanChange() {
    const option = this.subSelect.selectedOptions[0];
    if (!option) return;
    const card = this.subSelect.closest('[data-bundle-card]') || this.subSelect.closest('[data-subscription-card]');
    if (!card) return;

    const price = parseInt(option.dataset.price, 10);
    if (Number.isFinite(price)) {
      card.dataset.price = String(price);
      const priceEl = card.querySelector('[data-sub-price]');
      if (priceEl) priceEl.textContent = this.formatMoney(price);
    }
    card.dataset.sellingPlan = this.subSelect.value;

    const discEl = card.querySelector('.pdp-sub-card__discount');
    if (discEl && option.dataset.discount) discEl.textContent = option.dataset.discount;

    if (this.selectedCard === card) {
      this.applyBundleSelection(card);
    }
  }

  refreshSealSubsWidget(card) {
    if (this.subSelect) return;
    const target = document.querySelector('.sealsubs-target-element');
    if (!target) return;
    const isSub = card.dataset.isSub === 'true';
    target.hidden = !isSub;
    if (!isSub) return;
    const handle = card.dataset.handle;
    const productJson = card.dataset.productJson;
    if (handle) target.setAttribute('data-handle', handle);
    if (productJson) target.setAttribute('data-product', productJson);
    if (window.SealSubs && typeof window.SealSubs.refresh === 'function') {
      try { window.SealSubs.refresh(); } catch (e) { console.warn('[pdp-bundles] SealSubs.refresh failed', e); }
    }
  }

  initUpgradeItems() {
    this.upgradeItems.forEach(item => {
      const checkbox = item.querySelector('.pdp-upgrade-item__input');
      if (!checkbox) return;

      const sync = () => {
        item.classList.toggle('pdp-upgrade-item--checked', checkbox.checked);
        this.updateTotal();
      };

      item.addEventListener('click', e => {
        e.preventDefault();
        checkbox.checked = !checkbox.checked;
        sync();
      });

      sync();
    });
  }

  initQuantityButtons() {
    if (!this.quantityInput) return;

    this.section.querySelector('.pdp-quantity__btn--minus')?.addEventListener('click', () => {
      const val = parseInt(this.quantityInput.value, 10);
      if (val > 1) {
        this.quantityInput.value = val - 1;
        this.updateTotal();
      }
    });

    this.section.querySelector('.pdp-quantity__btn--plus')?.addEventListener('click', () => {
      this.quantityInput.value = parseInt(this.quantityInput.value, 10) + 1;
      this.updateTotal();
    });

    this.quantityInput.addEventListener('change', () => this.updateTotal());
  }

  initFormSubmit() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    this.cartUpdateUnsub = subscribe(PUB_SUB_EVENTS.cartUpdate, async ({ source }) => {
      if (source !== 'product-form' || this.addingAddons) return;
      const upgrades = this.getCheckedUpgrades();
      if (upgrades.length === 0) return;

      const variantIds = upgrades
        .map(item => parseInt(item.dataset.variantId, 10))
        .filter(id => Number.isFinite(id));
      if (variantIds.length === 0) return;

      this.addingAddons = true;
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const sectionIds = cart?.getSectionsToRender?.().map(s => s.id) || ['cart-icon-bubble'];

      try {
        for (const id of variantIds) {
          const res = await fetch(`${routes.cart_add_url}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ id, quantity: 1, sections: sectionIds, sections_url: window.location.pathname })
          });
          const data = await res.json();
          if (cart && data.sections) {
            try { cart.renderContents(data); } catch (e) { console.error('[pdp-addons] render error', e); }
          }
        }
        this.getCheckedUpgrades().forEach(item => {
          const cb = item.querySelector('.pdp-upgrade-item__input');
          if (cb) cb.checked = false;
          item.classList.remove('pdp-upgrade-item--checked');
        });
        this.updateTotal();
      } catch (e) {
        console.error('[pdp-addons] failed to add addons', e);
      } finally {
        this.addingAddons = false;
      }
    });
  }

  getCheckedUpgrades() {
    return [...this.upgradeItems].filter(item => {
      const cb = item.querySelector('.pdp-upgrade-item__input');
      return cb?.checked;
    });
  }

  updateTotal() {
    const qty = parseInt(this.quantityInput?.value || '1', 10) || 1;
    const upgradeTotal = this.getCheckedUpgrades().reduce((sum, item) => {
      const price = parseInt(item.dataset.price, 10);
      return sum + (Number.isFinite(price) ? price : 0);
    }, 0);

    const total = (this.basePrice || 0) * qty + upgradeTotal;
    if (this.totalPriceEl) this.totalPriceEl.textContent = this.formatMoney(total);
    this.updateButtonPrice(total);
  }

  updateButtonPrice(total) {
    if (!this.showButtonPrice || !this.submitBtnLabel || this.submitBtn?.disabled) return;
    this.submitBtnLabel.textContent = `${this.addToCartBaseText} – ${this.formatMoney(total)}`;
  }

  formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  initRecurringAccordion() {
    this.recurringAccordion = this.section.querySelector('[data-pdp-sub-card-accordion]');

    if (!this.recurringAccordion) return;

    this.recurringAccordionToggle = this.recurringAccordion.querySelector(
      '[data-pdp-sub-card-accordion-toggle]'
    );

    this.recurringAccordionContent = this.recurringAccordion.querySelector(
      '[data-pdp-sub-card-accordion-content]'
    );

    this.recurringAccordionLabel = this.recurringAccordion.querySelector(
      '[data-pdp-sub-card-accordion-label]'
    );

    if (
      !this.recurringAccordionToggle ||
      !this.recurringAccordionContent ||
      !this.recurringAccordionLabel
    ) {
      return;
    }

    this.recurringAccordionToggle.addEventListener('click', () => {
      const isOpen =
        this.recurringAccordionToggle.getAttribute('aria-expanded') === 'true';

      this.recurringAccordionToggle.setAttribute(
        'aria-expanded',
        String(!isOpen)
      );

      this.recurringAccordionContent.hidden = isOpen;
      this.recurringAccordionLabel.textContent = isOpen
        ? "What's included?"
        : 'Hide';

      this.recurringAccordion.classList.toggle(
        'pdp-sub-card__accordion--open',
        !isOpen
      );
    });
  }

  populateReplenishableLiquids(card) {
  const content = this.section.querySelector(
    '[data-pdp-sub-card-accordion-content]'
  );

  if (!content) return;

  const data = card.dataset.replenishableLiquids;

  if (!data) {
    /*content.innerHTML = '';*/
    return;
  }

  try {
    const liquids = JSON.parse(data);

    content.innerHTML = '';

    liquids.forEach(({ title, quantity }) => {
      const item = document.createElement('div');
      item.className = 'pdp-sub-card__accordion-item';

      const titleEl = document.createElement('span');
      titleEl.className = 'pdp-sub-card__accordion-item-title';
      titleEl.textContent = title;

      const quantityEl = document.createElement('span');
      quantityEl.className = 'pdp-sub-card__accordion-item-quantity';
      quantityEl.textContent = quantity;

      item.append(titleEl, quantityEl);
      content.appendChild(item);
    });
  } catch (error) {
    console.error('Failed to parse replenishable liquids:', error);
  }
}

}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-pdp-section]').forEach(el => {
    new PdpProductInfo(el);
  });
});
